import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

const ADMIN = `${MICROSERVICE_CONFIG.ACCOUNTING}/admin/rewards`;

export const get_reward_accounts_api = async (params) => {
	const response = await authenticatedApi.get(`${ADMIN}/accounts?${params}`);
	return response.data;
};

export const get_reward_ledger_api = async (params) => {
	const response = await authenticatedApi.get(`${ADMIN}/ledger?${params}`);
	return response.data;
};

export const get_reward_credits_api = async (params) => {
	const response = await authenticatedApi.get(`${ADMIN}/credits?${params}`);
	return response.data;
};

export const reverse_reward_ledger_entry_api = async ({ id, reason }) => {
	const response = await authenticatedApi.post(`${ADMIN}/ledger/${id}/reverse`, { reason });
	return response.data;
};

export const get_reward_tiers_api = async () => {
	const response = await authenticatedApi.get(`${MICROSERVICE_CONFIG.ACCOUNTING}/rewards/tiers`);
	return response.data;
};
